/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountListFilters {
    getFixupPrototypeFunction() { return MasterAccountListFilters.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountListFilters>): MasterAccountListFilters {
        let obj = Object.assign(new MasterAccountListFilters(), model);
        MasterAccountListFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountListFilters>): MasterAccountListFilters {
        if (!model) return null;
        return MasterAccountListFilters.newInstance(<MasterAccountListFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountListFilters) {
        if (!obj) return;

        models.MasterAccountListFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountListFilters): boolean {
        Object.setPrototypeOf(obj, MasterAccountListFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Text query to search by name and status
     */
    search: string;

    /**
     * Status of the master account
     */
    status: models.MasterAccountStatus;

    /**
     * Status of the master account subscription
     */
    account_status: models.MasterAccountSubscriptionStatus;

    /**
     * Auth type of the master account
     */
    auth_type: models.MasterAccountAuthType;

    /**
     * Datetime string to filter accounts by created date. Format: yyyy-mm-dd hh:mm:ss.fff
     */
    created_from: string;

}
